import * as React from 'react';
import Stack from "@mui/material/Stack";
import { activityItem, RevisionPermisions, wfDocument } from "../../types/types";
import Box from "@mui/material/Box";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import Table from '@mui/material/Table';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import IconButton from '@mui/material/IconButton';
import { ChatBubbleOutline,VisibilityOutlined } from '@mui/icons-material';
import Popover from '@mui/material/Popover';
import { actionTypes, currPathValue, pdfMode, saveButtonMode, uiItemNames } from '../../types/enums';
import CircularProgress from '@mui/material/CircularProgress';
import store from '../../configureStore';
import { Button } from '@mui/material';
import { CommentList } from '../DataTables/CommentList';
import MenuItem from '@mui/material/MenuItem';
import Webcam from "react-webcam";
import { fields, mapFieldToText } from "../../lang/constants";
import { setStateItem } from '../../actions/actionsBase';
import { toLocaleUTCDateString } from '../../actions/folderViewActions';

interface ProarcActivityProps {
    activity: activityItem|null;
    // activityDecisions: activityDecisions|null;
    actDataLoading: boolean;
    onLoadPdf: (fileRno:number, clientSide:boolean, mode: pdfMode, saveBtnMode: saveButtonMode) => void;
    // onAddComment: (wfRno:number,actRno:number,docRno:number,commLevel:number, commInput:string) => void;
    onAddComment: (docRno:number,commLevel:number,commInput:string,wfRno?:number,actRno?:number,file?:Blob, filename?: string, revRno?:number) => void;
    onCloseActivity: (wfRno:number, actRno:number, decision:string) => void;
}

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
  }
  
function CustomTabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;
  
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
      </div>
    );
  }

function a11yProps(index: number) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }

export const ProarcWfActivity = (props:ProarcActivityProps) => {
    const [value, setValue] = React.useState(0);
    const [commLevel, setCommLevelValue] = React.useState(0); //0 document 10 aktivity level
    const [commDocRno, setCommDocRno] = React.useState(-1);
    const [commRevRno, setCommRevRno] = React.useState(-1);
    const [commInput, setCommInput] = React.useState<string>("");
    const [choise, setChoise] = React.useState("");
    const [webCamEnabled, setWebCamEnabled] = React.useState<boolean>(false);
    const [webCamModeUser, setWebCamMode] = React.useState<boolean>(false);
    const [videoConstraints, setVideoConstraints] = React.useState<boolean | MediaTrackConstraints | undefined>({facingMode: { exact: "environment" }});
    const webcamRef = React.useRef<Webcam>(null);
    const [imgSrc, setImgSrc] = React.useState<string | null | undefined>(null);

    const capture = React.useCallback(() => {
        const imageSrc = webcamRef.current?.getScreenshot();
        setImgSrc(imageSrc);
        
    }, [webcamRef, setImgSrc]);

    const changeWebcamMode = () => {
        if(webCamModeUser) { 
            setWebCamMode(false);
            setVideoConstraints({facingMode: { exact: "environment" }});
        }
        else
        {
            setWebCamMode(true);
            setVideoConstraints({facingMode: "user"});
        }
    }


    // const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);
    const [anchorElComm, setAnchorElComm] = React.useState<HTMLButtonElement | null>(null);
    const [anchorElCamera, setAnchorElCamera] = React.useState<HTMLButtonElement | null>(null);
    const [anchorElCloseAct, setAnchorElCloseAct] = React.useState<HTMLButtonElement | null>(null);

    const handleChoiseChange = (value:string) => {setChoise(value);};

    const handleCommInputChange = (searchInput: string) => {setCommInput(searchInput);};

    const handleCommLevelChange = (level: number, docRno:number, revRno:number) => {
        setCommLevelValue(level);
        setCommDocRno(docRno);
        setCommRevRno(revRno);
    };  

    //const openPopover = (event: React.MouseEvent<HTMLButtonElement>) => {setAnchorEl(event.currentTarget); };
    // const handleClose = () => { setAnchorEl(null);};
    // const open = Boolean(anchorEl);
    // const popoverId = open ? 'pdfTron-popover' : undefined;

    const openPopoverComm = (event: React.MouseEvent<HTMLButtonElement>,withCamera:boolean) => {
        setAnchorElComm(event.currentTarget);
        setWebCamEnabled(withCamera);
    };
    const handleCloseComm = () => {setAnchorElComm(null); setImgSrc(null);};
    const openComm = Boolean(anchorElComm);
    const popoverIdComm = openComm ? 'simple-popover-comm' : undefined;

    const openPopoverCamera = (event: React.MouseEvent<HTMLButtonElement>) => {setAnchorElCamera(event.currentTarget);};
    const handleCloseCamera = () => {setAnchorElCamera(null);};
    const openCamera = Boolean(anchorElCamera);
    const popoverIdCamera = openCamera ? 'simple-popover-Camera' : undefined;

    const openPopoverCloseAct = (event: React.MouseEvent<HTMLButtonElement>) => {setAnchorElCloseAct(event.currentTarget);};
    const handleCloseCloseAct = () => {setAnchorElCloseAct(null);};
    const openCloseAct = Boolean(anchorElCloseAct);
    const popoverIdCloseAct = openCloseAct ? 'simple-popover-CloseAct' : undefined;

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {setValue(newValue);};
     
    const docTabTitle = `${mapFieldToText(fields.ACTIVITY_DOCUMENTS)} (${props.activity?.WfDocuments === undefined ? "0": props.activity?.WfDocuments.length})`;
    const commTabTitle = `${mapFieldToText(fields.ACTIVITY_COMMENTS)} (${props.activity?.WfComments === undefined ? "0": props.activity?.WfComments.length})`;
    const addCommTitle = `${mapFieldToText(fields.ADD)} ${commLevel === 0 ? mapFieldToText(fields.ACTIVITY_DOCUMENT): mapFieldToText(fields.ACTIVITY_ACTIVITY)} ${mapFieldToText(fields.ACTIVITY_COMMENT)}`;



    if(props.activity===null )
    {
        return <></>
    }
    else
    {
        console.log("render activity")
        return (
            <Stack sx={{ width: '100%' }}>
                {props.actDataLoading &&
                    <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center'  }}>
                        <CircularProgress />
                    </Box>
                }
                {!props.actDataLoading &&
                    <Box sx={{ width: '100%' }}>
                         {
                            props.activity?.ClosedDate==="0001-01-01T00:00:00"
                            && 
                            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                                    <Button variant="contained" 
                                            size="small" 
                                            aria-describedby={popoverIdCloseAct}
                                            aria-label="Close activity"
                                            onClick={(event: React.MouseEvent<HTMLButtonElement>)=>{
                                                if((props.activity?.Decisions?.choices !== undefined ? props.activity?.Decisions?.choices.length : 0) !== 0)
                                                {
                                                    openPopoverCloseAct(event);
                                                }
                                                else
                                                {
                                                    console.log("close without popover");
                                                    props.onCloseActivity(props.activity!.WorkflowItem.Id,props.activity!.Id,choise);
                                                }
                                            }}
                                    >
                                        {mapFieldToText(fields.CLOSE_ACTIVITY)}
                                    </Button> 
                                    <Popover
                                    id={popoverIdCloseAct}
                                    open={openCloseAct}
                                    anchorEl={anchorElCloseAct}
                                    marginThreshold={20}
                                    anchorOrigin={{
                                        vertical: 'top',
                                        horizontal: 'center',
                                    }}
                                    transformOrigin={{
                                        vertical: 'top',
                                        horizontal: 'right',
                                    }}
                                    onClose={handleCloseCloseAct}
                                    slotProps={{paper: {style: { width: '50%'}}}}
                                >
                                    <Stack sx={{p:1}}>
                                            <Typography>{props.activity.Decisions?.question}</Typography>
                                            <TextField select
                                                        variant="standard"
                                                        defaultValue=""
                                                        value = {choise}
                                                        size="small"
                                                        sx={{ mb: 1 }}
                                                        onChange={(event)=>handleChoiseChange(event.target.value)}
                                            >
                                                {[<MenuItem value=""></MenuItem>].concat(props.activity?.Decisions?.choices !== undefined ? props.activity.Decisions!.choices.map(x=><MenuItem value={x.choice}>{x.choice}</MenuItem>) : [])}
                                            </TextField>
                                            <Button variant="contained" 
                                                    size="small" 
                                                    onClick={(event: React.MouseEvent<HTMLButtonElement>)=>{
                                                                console.log(`Close with decision ${choise}`);
                                                                props.onCloseActivity(props.activity!.WorkflowItem.Id,props.activity!.Id,choise);
                                                                handleChoiseChange("");
                                                                handleCloseCloseAct();
                                                            }}>
                                                {mapFieldToText(fields.ACTIVITY_CLOSE)}
                                            </Button>
                                    </Stack>
                                </Popover>  
                            </Box>                   
                        }
                        {   props.activity?.ClosedDate!=="0001-01-01T00:00:00"
                            &&
                            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                                <Typography>
                                    {mapFieldToText(fields.ACTIVITY_CLOSED_ON)}: {toLocaleUTCDateString(props.activity?.ClosedDate,false)}
                                    {/* {props.activity?.ClosedDate.split('.')[0].replace('T', ' ')} */}
                                </Typography>
                            </Box>
                        } 
                        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                            <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
                                <Tab label={docTabTitle} {...a11yProps(0)} sx={{flexGrow:1, fontWeight: 'bold'}}/>
                                <Tab label={commTabTitle} {...a11yProps(1)} sx={{ flexGrow: 1, fontWeight: 'bold' }}/>
                            </Tabs>
                        </Box>
                        <CustomTabPanel value={value} index={0}>
                            <Table size="small" padding="none">
                                {
                                    props.activity.WfDocuments.map((doc:wfDocument) => {
                                        const paDoc = props.activity!.PaDocuments.filter(x=>x.DocRno === doc.documentRno)[0];
                                        const rev = paDoc.Revisions.concat(paDoc.CurrentRevision).filter(x=>x.RevRno === doc.revisionRno).length > 0 ? 
                                                            paDoc.Revisions.concat(paDoc.CurrentRevision).filter(x=>x.RevRno === doc.revisionRno)[0]
                                                            : {Files: [], RevisionCode: "Document level", Status : "", RevRno: 0};
                                        // const prevRev = paDoc.Revisions.concat(paDoc.CurrentRevision).filter(x=>x.RevRno === rev.RevRno-1).length > 0 ? 
                                        //                     paDoc.Revisions.concat(paDoc.CurrentRevision).filter(x=>x.RevRno === rev.RevRno-1)[0]
                                        //                     : {Files: [], RevisionCode: "Document level", Status : "", RevRno: 0};
                                        return  <>
                                                    <TableRow>
                                                        <TableCell colSpan={2}>
                                                            <Typography variant="h6"><b>{doc.documentId} - {doc.documentTitle} - ({rev.RevisionCode}-{rev.Status})</b></Typography>
                                                        </TableCell>
                                                        <TableCell>
                                                            <Button variant="contained" 
                                                                    size="small" 
                                                                    key={paDoc.DocRno}
                                                                    aria-describedby={popoverIdComm}
                                                                    aria-label="Add comment"
                                                                    onClick={(event: React.MouseEvent<HTMLButtonElement>)=>{
                                                                        openPopoverComm(event,true);
                                                                        handleCommLevelChange(0,paDoc.DocRno,rev.RevRno);
                                                                    }}
                                                                    disabled={props.activity?.ClosedDate!=="0001-01-01T00:00:00"}
                                                            >
                                                                {mapFieldToText(fields.ADD)} {mapFieldToText(fields.DOCUMENT_COMMENT)}
                                                            </Button>                                                            
                                                        </TableCell>
                                                    </TableRow>
                                                    {rev.Files.filter(x=>(store.getState().appSettings.validFileTypes as string).includes(x.Extension)).map(file=>{

                                                        const perms:RevisionPermisions[] = (store.getState().uiItems.revisionPermisions as RevisionPermisions[]).filter(x=>x.DocRno===doc.documentRno && x.RevRno === doc.revisionRno);
                                                        let canComment = false;
                                                        if(perms.length>0)
                                                        {
                                                            canComment=perms[0].FileUserAccesses.filter(x=>x.FileRno === file.FileRno).length>0 
                                                                            ? 
                                                                            (
                                                                                //perms[0].FileUserAccesses.filter(x=>x.FileRno === file.FileRno)[0].CanCheckOutForCommenting
                                                                                perms[0].FileUserAccesses.filter(x=>x.FileRno === file.FileRno)[0].CanEdit
                                                                                && (
                                                                                        props.activity?.ActivityTemplate.WorkflowTemplateId.toString()===store.getState().appSettings.ertms.type.toString()
                                                                                        ||
                                                                                        props.activity?.ActivityTemplate.WorkflowTemplateId.toString()===store.getState().appSettings.retteflyt.type.toString()
                                                                                    )
                                                                                &&
                                                                                props.activity?.ClosedDate==="0001-01-01T00:00:00"
                                                                            )
                                                                            : false;
                                                        }
                                                        return  <TableRow>
                                                            <TableCell>
                                                                {file.Name}
                                                            </TableCell>
                                                            <TableCell>
                                                                {(file.Size / (1024 * 1024)).toFixed(2) + ' MB'}
                                                            </TableCell>
                                                            <TableCell>
                                                                {file.Comment}
                                                            </TableCell>
                                                            <TableCell>
                                                                <IconButton
                                                                    // aria-describedby={popoverId}
                                                                    edge="end"
                                                                    aria-label="do search"
                                                                    onClick={(event: React.MouseEvent<HTMLButtonElement>)=>{
                                                                        // openPopover(event);
                                                                        props.onLoadPdf(file.FileRno,true, canComment === true? pdfMode.edit : pdfMode.view, props.activity?.WorkflowItem.WorkflowTemplateId === store.getState().appSettings.ertms.type ? saveButtonMode.save :saveButtonMode.saveAsAttachment);
                                                                        store.dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.currentPath, currPathValue.PdfTron));
                                                                        //store.dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.previousPath, [currPathValue.WfActivity]));  
                                                                        store.dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.previousPath, [...store.getState().uiItems.previousPath].concat([currPathValue.WfActivity])));
                                                                    }}
                                                                    color="inherit"
                                                                    >
                                                                    {canComment === true ? <ChatBubbleOutline /> : <VisibilityOutlined /> }
                                                                </IconButton>

                                                                {/* {!canComment && <IconButton
                                                                    // aria-describedby={popoverId}
                                                                    edge="end"
                                                                    aria-label="do search"
                                                                    onClick={(event: React.MouseEvent<HTMLButtonElement>)=>{
                                                                        // openPopover(event);
                                                                        props.onLoadPdf(file.FileRno,true,pdfMode.view, saveButtonMode.save);
                                                                        store.dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.currentPath, currPathValue.PdfTron));
                                                                        store.dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.previousPath, [currPathValue.WfActivity]));  
                                                                    }}
                                                                    color="inherit"
                                                                    >
                                                                    <VisibilityOutlined />
                                                                </IconButton>   }
                                                                {canComment && <IconButton
                                                                    // aria-describedby={popoverId}
                                                                    edge="end"
                                                                    aria-label="do search"
                                                                    onClick={(event: React.MouseEvent<HTMLButtonElement>)=>{
                                                                        // openPopover(event);
                                                                        props.onLoadPdf(file.FileRno,true,pdfMode.edit,props.activity?.WorkflowItem.WorkflowTemplateId === store.getState().appSettings.ertms.type ? saveButtonMode.save :saveButtonMode.saveAsAttachment);
                                                                        store.dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.currentPath, currPathValue.PdfTron));
                                                                        store.dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.previousPath, [currPathValue.WfActivity]));  
                                                                    }}
                                                                    color="inherit"
                                                                    >
                                                                    <ChatBubbleOutline />
                                                                </IconButton>   } */}
                                                            </TableCell>
                                                        </TableRow>
                                                        })}
                                                </>  
                                        }
                                    )
                                }
                            </Table>
                        </CustomTabPanel>
                        <CustomTabPanel value={value} index={1}>
                            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 1 }}>
                                <Button variant="contained" 
                                        size="small" 
                                        key={props.activity.Id}
                                        sx={{mb:1}}
                                        // aria-describedby={popoverId}
                                        //edge="end"
                                        aria-label="Add document comment"
                                        onClick={(event: React.MouseEvent<HTMLButtonElement>)=>{
                                            openPopoverComm(event,false);
                                            handleCommLevelChange(10,-1,-1);
                                        }}
                                        disabled={props.activity?.ClosedDate!=="0001-01-01T00:00:00"}
                                >
                                    {mapFieldToText(fields.ADD)} {mapFieldToText(fields.ACTIVITY_COMMENT)}
                                </Button>
                            </Box>
                            <CommentList comments={props.activity.WfComments} LoadPdf={props.onLoadPdf} //openPopover={openPopover} 
                            parent={currPathValue.WfActivity}/>
                        </CustomTabPanel>
                    </Box>  
                }
                {/* Take picture popover */}
                <Popover
                    id={popoverIdCamera}
                    open={openCamera}
                    anchorEl={anchorElCamera}
                    marginThreshold={20}
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'center',
                      }}
                      transformOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                      }}
                    onClose={handleCloseCamera}
                    slotProps={{paper: {style: { width: '50%'}}}}
                >
                    <Stack sx={{p:1}}>
                            {imgSrc && (
                                <>
                                    <img src={imgSrc} alt="webCapture"/>
                                    <Button variant="contained" 
                                        size="small" 
                                        onClick={handleCloseCamera}>
                                        {mapFieldToText(fields.ATTACH_TO_COMMENT)}
                                    </Button>
                                    <Button variant="contained" 
                                        size="small" 
                                        onClick={()=>setImgSrc(null)}>
                                        {mapFieldToText(fields.TAKE_NEW_PICTURE)}
                                    </Button>
                                </> 
                            )}
                            {(imgSrc === null || imgSrc === undefined) && (
                                <>
                                    <Webcam
                                        audio={false}
                                        ref={webcamRef}
                                        screenshotFormat="image/jpeg"
                                        videoConstraints={videoConstraints}
                                    />
                                     <Button variant="contained" 
                                        size="small" 
                                        onClick={capture}>
                                        {mapFieldToText(fields.TAKE_PICTURE)}
                                    </Button>
                                    <Button variant="contained" 
                                        size="small" 
                                        onClick={changeWebcamMode}>
                                        {mapFieldToText(fields.CHANGE_CAM_MODE)}
                                    </Button>
                                </>
                            )}
                            
                    </Stack>
                </Popover>
                {/* Add comment popover */}
                <Popover
                    id={popoverIdComm}
                    open={openComm}
                    anchorEl={anchorElComm}
                    marginThreshold={20}
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'center',
                      }}
                      transformOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                      }}
                    onClose={handleCloseComm}
                    slotProps={{paper: {style: { width: '50%'}}}}
                >
                    <Stack sx={{p:1}}>
                            <TextField
                                id="outlined-multiline-flexible"
                                label="Add comment"
                                multiline
                                rows={3}
                                value={commInput} 
                                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {handleCommInputChange(event.target.value);}}
                            />
                            {imgSrc && (
                                <>
                                    <Typography>capture.jpeg</Typography>
                                    <Button variant="contained" 
                                        size="small" 
                                        onClick={(event: React.MouseEvent<HTMLButtonElement>)=>{
                                                    const picBlob=convertBase64ToBlob(imgSrc); 
                                                    props.onAddComment(    commDocRno,
                                                                            commLevel,
                                                                            commInput,
                                                                            props.activity!.WorkflowItem.Id,
                                                                            props.activity!.Id,
                                                                            picBlob,
                                                                            "capture.jpeg",
                                                                            commRevRno
                                                                        );
                                                    handleCloseComm();
                                                    handleCommInputChange("");
                                                }}
                                        disabled={commInput===""}
                                        >
                                        {addCommTitle}
                                    </Button>
                                </>
                            )}
                            {(imgSrc === null || imgSrc === undefined) && (
                                <>
                                    { webCamEnabled && 
                                        <Button variant="contained" 
                                            size="small" 
                                            aria-describedby={popoverIdCamera}
                                            aria-label="Take picture"
                                            onClick={(event: React.MouseEvent<HTMLButtonElement>)=>{
                                                openPopoverCamera(event);
                                            }}
                                            disabled={props.activity?.ClosedDate!=="0001-01-01T00:00:00"}
                                            >
                                                {mapFieldToText(fields.TAKE_PICTURE)}
                                        </Button>
                                    }
                                    <Button variant="contained" 
                                        size="small" 
                                        onClick={(event: React.MouseEvent<HTMLButtonElement>)=>{
                                                    props.onAddComment(    commDocRno,
                                                                            commLevel,
                                                                            commInput,
                                                                            props.activity!.WorkflowItem.Id,
                                                                            props.activity!.Id
                                                                        );
                                                    handleCloseComm();
                                                    handleCommInputChange("");
                                                }}
                                        disabled={commInput===""}
                                        >
                                        {addCommTitle}
                                    </Button>
                                </>
                            )}
                            
                    </Stack>
                </Popover>
            </Stack>
        )
    }
}

function convertBase64ToBlob(base64Image: string) {
  // Split into two parts
  const parts = base64Image.split(';base64,');

  // Hold the content type
  const imageType = parts[0].split(':')[1];

  // Decode Base64 string
  const decodedData = window.atob(parts[1]);

  // Create UNIT8ARRAY of size same as row data length
  const uInt8Array = new Uint8Array(decodedData.length);

  // Insert all character code into uInt8Array
  for (let i = 0; i < decodedData.length; ++i) {
    uInt8Array[i] = decodedData.charCodeAt(i);
  }

  // Return BLOB image after conversion
  return new Blob([uInt8Array], { type: imageType });
}